"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendGridService = void 0;
class SendGridService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Webhook handler from SendGrid
     * @param xTwilioEmailEventWebhookSignature
     * @param xTwilioEmailEventWebhookTimestamp
     * @returns any Successful response
     * @throws ApiError
     */
    receiveSendGridEvent(xTwilioEmailEventWebhookSignature, xTwilioEmailEventWebhookTimestamp) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/ext/sendgrid/events',
            headers: {
                'X-Twilio-Email-Event-Webhook-Signature': xTwilioEmailEventWebhookSignature,
                'X-Twilio-Email-Event-Webhook-Timestamp': xTwilioEmailEventWebhookTimestamp,
            },
        });
    }
}
exports.SendGridService = SendGridService;
